import React, {Component} from 'react'
import {Button, Collapse} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

import ProjectFeeRatesList from "./ProjectFeeRatesList";
import ProjectFeeRateInput from "./ProjectFeeRateInput";
//import ProjectBudgetInput from "./ProjectBudgetInput";

export default class ProjectBudget extends Component{

    state = {
        showInput: false
    }

    add = () => {
        this.setState({showInput: !this.state.showInput})
    }

    render(){

        const {props, state} = this

        return(
            <div>
                <Button
                    size="sm"
                    color={state.showInput ? 'warning' : 'success'}
                    onClick={this.add}
                >
                    <FontAwesomeIcon color="#fff" icon={state.showInput ? 'minus' : 'plus'}/>{' '}
                    {state.showInput ? 'Cancel' : 'Add Fee Rate'}
                </Button>

                <Collapse isOpen={state.showInput}>
                    <div className="d-flex flex-column pt-3 mt-3 card card-body bg-light">
                        <ProjectFeeRateInput
                            project_id={props.project_id}
                            onCancel={() => this.setState({showInput: false})}
                            onSaved={() => this.setState({showInput: false})}
                            successMessage="Fee Rate Added"
                        />
                    </div>
                </Collapse>


                <ProjectFeeRatesList
                    project_id={props.project_id}
                    rates={props.rates}
                />
            </div>

        )
    }

}

ProjectBudget.propTypes = {
    project_id: PropTypes.string.isRequired,
    rates: PropTypes.array,
}
